// extracted by css-extract-rspack-plugin
export default {"root":"root-LBY0Ht text-body-md","hidden":"hidden-hozhJd sr-only","errorList":"errorList-cdfdKA"};